import React, { useEffect, createElement } from 'react';
import { Navbar } from '../components/Navbar';
import { HeroSection } from '../components/HeroSection';
import { IdentificationSection } from '../components/IdentificationSection';
import { ProblemSection } from '../components/ProblemSection';
import { BeliefShiftSection } from '../components/BeliefShiftSection';
import { ProductIntroSection } from '../components/ProductIntroSection';
import { PhasesSection } from '../components/PhasesSection';
import { DifferentiationSection } from '../components/DifferentiationSection';
import { IncludedSection } from '../components/IncludedSection';
import { FaqSection } from '../components/FaqSection';
import { FutureVisionSection } from '../components/FutureVisionSection';
import { FinalCtaSection } from '../components/FinalCtaSection';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
export function LandingPage() {
  useEffect(() => {
    // Meta Pixel initialization
    if (!window.fbq) {
      const n: any = window.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!window._fbq) window._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const t = document.createElement('script');
      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const s = document.getElementsByTagName('script')[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      }
      window.fbq('init', '891090260291826');
      window.fbq('track', 'PageView');
    }
  }, []);
  return <div className="bg-primary min-h-screen text-white selection:bg-gold selection:text-primary" data-id="element-159">
      {/* Meta Pixel noscript fallback */}
      <noscript data-id="element-160">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=891090260291826&ev=PageView&noscript=1" alt="" data-id="element-161" />
      </noscript>

      <Navbar data-id="element-162" />
      <HeroSection data-id="element-163" />
      <IdentificationSection data-id="element-164" />
      <ProblemSection data-id="element-165" />
      <BeliefShiftSection data-id="element-166" />
      <ProductIntroSection data-id="element-167" />
      <PhasesSection data-id="element-168" />
      <DifferentiationSection data-id="element-169" />
      <IncludedSection data-id="element-170" />
      <FaqSection data-id="element-171" />
      <FutureVisionSection data-id="element-172" />
      <FinalCtaSection data-id="element-173" />

      <footer className="py-12 bg-black text-center text-gray-600 text-sm" data-id="element-174">
        <p data-id="element-175">
          &copy; {new Date().getFullYear()} The F-Formula. Todos los derechos
          reservados.
        </p>
      </footer>
    </div>;
}